import React from 'react';
import FormInput from '../atoms/FormInput';
import DatePicker from '../atoms/DatePicker';

/**
 * TravelForm - Formulario de itinerario de viaje (todos los campos opcionales)
 *
 * Props:
 * - arrivalDate: Valor actual de fecha de llegada
 * - arrivalAirlineFlight: Valor actual de aerolínea/vuelo de llegada
 * - departureDate: Valor actual de fecha de salida
 * - departureAirlineFlight: Valor actual de aerolínea/vuelo de salida
 * - onChange: Función callback (fieldName, value) => void
 * - errors: Objeto con errores { arrivalDate, arrivalAirlineFlight, departureDate, departureAirlineFlight }
 * - className: Clases CSS adicionales (opcional)
 */
function TravelForm({
  arrivalDate = '',
  arrivalAirlineFlight = '',
  departureDate = '',
  departureAirlineFlight = '',
  onChange,
  errors = {},
  className = ''
}) {
  const handleChange = (fieldName) => (e) => {
    onChange(fieldName, e.target.value);
  };

  return (
    <div className={`d-flex flex-column gap-3 px-2 ${className}`}>
      {/* Arrival Date */}
      <DatePicker
        label="Fecha de Llegada"
        placeholder="DD/MM/YYYY"
        value={arrivalDate}
        onChange={handleChange('arrivalDate')}
        error={errors.arrivalDate}
        min={new Date().toISOString().split('T')[0]}
      />

      {/* Arrival Airline & Flight */}
      <FormInput
        label="Aerolínea y Vuelo de Llegada"
        placeholder="Ej: Avianca AV123"
        value={arrivalAirlineFlight}
        onChange={handleChange('arrivalAirlineFlight')}
        error={errors.arrivalAirlineFlight}
      />

      {/* Departure Date */}
      <DatePicker
        label="Fecha de Salida"
        placeholder="DD/MM/YYYY"
        value={departureDate}
        onChange={handleChange('departureDate')}
        error={errors.departureDate}
        min={arrivalDate || new Date().toISOString().split('T')[0]}
      />

      {/* Departure Airline & Flight */}
      <FormInput
        label="Aerolínea y Vuelo de Salida"
        placeholder="Ej: Avianca AV456"
        value={departureAirlineFlight}
        onChange={handleChange('departureAirlineFlight')}
        error={errors.departureAirlineFlight}
      />
    </div>
  );
}

export default TravelForm;
